import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';

const { retainerBackground, retainerTextColor } = Colors;

export const Section = styled.section`
    background: ${retainerBackground};
    min-height: 50px;
    display: flex;
    align-items: center;
    padding: 0 28px 0 28px;
    border-radius: 4px;
    box-shadow: 0px 0px 3px rgba(23, 26, 31, 0.12);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    overflow: visible;
    position: relative;
    z-index: 1;
`;

export const Title = styled.h4`
    ${TextStyle({ fontSize: '16px', fontWeight: '400', color: retainerTextColor })};
`;
